type CompanyImage = {
  url: string;
  name: string;
};

export const CompanyImages: CompanyImage[] = [
  { url: '/static/images/company-0.svg', name: 'Netflix' },
  { url: '/static/images/company-1.svg', name: 'Microsoft' },
  { url: '/static/images/company-2.svg', name: 'Spotify' },
  { url: '/static/images/company-3.svg', name: 'Slack' },
  { url: '/static/images/company-4.svg', name: 'Google' },
];
